import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_TRIAL,
  STORE_TRIAL_MERCHANT_IS_ABLE_TO_TRANSACT,
} from 'constants/store'
import { ErrorStore, MerchantIsAbleToTransactResponse } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type MerchantIsAbleToTransactState = MerchantIsAbleToTransactResponse

type State = GenericState<MerchantIsAbleToTransactState>

export const initialState: State = {
  data: {
    company_name: '',
    is_able_to_transact: false,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchMerchantIsAbleToTransact = createAsyncThunk<
  MerchantIsAbleToTransactState,
  Promise<MerchantIsAbleToTransactResponse>,
  Payload
>(
  STORE_TRIAL_MERCHANT_IS_ABLE_TO_TRANSACT,
  async (
    promise: Promise<MerchantIsAbleToTransactResponse>,
    { rejectWithValue }
  ) => {
    try {
      const response = await promise

      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  MerchantIsAbleToTransactState,
  MerchantIsAbleToTransactResponse,
  Payload
>(fetchMerchantIsAbleToTransact, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_TRIAL,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear } = actions

export { clear }

export default reducer
